import React, { useState, useEffect } from "react";
import axios from "axios";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Loader from "./utilities/loader";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { titleCase, nthPosition } from "./helpers/formatter";
import Paper from "@mui/material/Paper";
import CountDown from "./utilities/countdown";
const url = process.env.REACT_APP_API_GET_TOP_USERS;

export default function Champs() {
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const { day, hour, min, sec } = CountDown("July 31, 2025");

  useEffect(() => {
    axios
      .get(url)
      .then(({ data }) => {
        setUsers(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Container maxWidth="lg">
      {loading && <Loader />}
      <Box sx={{ textAlign: "center", marginBottom: 2 }}>
        <Typography variant="h6" fontWeight="bold">
          Kiddies Crown Leaderboard
        </Typography>
        <Typography fontWeight="bold">
          {/* WINNERS will emerge in {day}d & {hour}h: {min}m: {sec}s{" "} */}
          Winners of the Kiddies Crown Contest.
        </Typography>
      </Box>
      <Box>
        {users.map((user, index) => (
          <Paper elevation={3}>
            <Box
              key={index}
              sx={{
                width: "100%",
                height: {
                  md: 200,
                  xs: 100,
                },
                backgroundColor: "#fff",
                borderRadius: 5,
                display: "flex",
                justifyItems: "center",
                marginBottom: {
                  md: 4,
                  xs: 2,
                },
              }}
            >
              <Box
                sx={{
                  width: {
                    xs: "80px",
                    sm: "170px",
                  },
                  height: {
                    xs: "80px",
                    sm: "170px",
                  },
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "flex-start",
                  borderRadius: "50%",
                }}
              >
                <img
                  src={`https://kidscrown.net/${user.picture}`}
                  alt=""
                  width="100%"
                />
              </Box>
              <Divider
                orientation="vertical"
                flexItem
                sx={{
                  marginX: {
                    md: 5,
                    xs: 1,
                  },
                }}
              />
              <Box>
                <Typography
                  variant="h6"
                  fontWeight="bold"
                  sx={{
                    fontSize: {
                      xs: 15,
                      sm: 30,
                    },
                  }}
                >
                  {titleCase(user.name)}
                </Typography>

                {index === 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      marginY: { md: 2, xs: 0 },
                    }}
                  >
                    <Typography
                      fontWeight="bold"
                      sx={{ fontSize: { xs: 14, md: 16 } }}
                    >
                      Grand Winner
                    </Typography>
                    🏆
                  </Box>
                )}
                {index !== 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      marginY: { md: 2, xs: 0 },
                    }}
                  >
                    <Typography
                      fontWeight="bold"
                      sx={{ fontSize: { xs: 14, md: 16 } }}
                    >
                      {nthPosition(index)} Runner-up{" "}
                    </Typography>
                    🏅
                  </Box>
                )}

                <Button
                  target="_blank"
                  variant="outlined"
                  size="small"
                  href={`https://kidscrown.net/contestant/${user.id}`}
                >
                  see profile
                </Button>
              </Box>
            </Box>
          </Paper>
        ))}
      </Box>
    </Container>
  );
}
